module.exports = __webpack_public_path__ + "static/media/iPhone14-8.5ac42d5d.png";